var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.02 13.645a4.872 4.872 0 00-1.512.236l-.918-2.06-1.502-3.366h-2.332a.55.55 0 100 1.1h1.62l.91 2.02c-1.888.412-2.53 2.267-3.063 3.797a6.453 6.453 0 01-1.067 2.217 1.97 1.97 0 00-1.69-.951 2.815 2.815 0 00-.286.02l-2.184-4.886 1.61-.373a.36.36 0 00.297-.353.37.37 0 00-.366-.363H10.28a.854.854 0 100 1.707.64.64 0 00.198-.03l1.412-.333.643 1.422-2.046 1.639a4.94 4.94 0 101.442 4.052h1.63a1.977 1.977 0 003.864-.373 5.552 5.552 0 001.827-3.051c.633-1.805 1.136-2.963 2.49-3.12l.77 1.727a4.982 4.982 0 102.51-.677zM14.172 17.11a1.966 1.966 0 00-.612.941h-1.63a4.796 4.796 0 00-.751-2.109l1.818-1.452zM6.98 22.348a3.78 3.78 0 01-3.745-3.208H6.98a.986.986 0 00.593-.206l2.687-2.179a3.75 3.75 0 01-3.28 5.593zm18.04 0a3.75 3.75 0 01-2.024-6.927l1.521 3.395a.548.548 0 00.504.324.63.63 0 00.227-.05.534.534 0 00.277-.716l-1.522-3.394a3.859 3.859 0 011.017-.137 3.753 3.753 0 110 7.505z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--bike-city-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'BikeCityIcon';
export default Icon;